<script>
import ActionBar from '@/components/core/ActionBar.vue';

export default {
  extends: ActionBar,
  data() {
    return {
      resourceName: 'ChemicalCost',
      urlFragment: 'chemicals',
    };
  },
};
</script>

<style></style>
